import { AxiosResponse } from 'axios'
import { get } from '../../utils/api'

export const fetchContest = (): Promise<AxiosResponse> =>
  get('/contests/current')

export const fetchWorks = (
  contest_id: string,
  search: string,
  size: number,
  page: number
): Promise<AxiosResponse> =>
  get('/contests/works', {
    'filter[contest_id]': contest_id,
    'filter[title]': search,
    'filter[with_avg_score]': true,
    size,
    page,
    sort: '-avg_score',
    include: [
      'user',
      'contest',
      'nomination',
      'ageCategory',
      'attachments',
      'user.profile',
      'answers',
      'answers.contestField',
    ].join(','),
  })
